import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage';
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
@inject('webEDIShipToStore','uiState')
@observer
class FormImport extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
  }

  beforeUpload = (file, FileList) => {
    return true
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)

    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`,
    }
  }

  onChange = (info) => {
    const { webEDIShipToStore, handleCancel} = this.props
    const { searchItem } = webEDIShipToStore
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        handleCancel()
        alertMessage.success('Import Success！')
        webEDIShipToStore.onSearchShipToAction(searchItem,1,PAGE_SIZE_DEFAULT)
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('Import Failed！')
    }
  }
  handleExport = () => {
    const { uiState, webEDIShipToStore } = this.props
    const { searchItem } = webEDIShipToStore
    uiState.onChangeFetchingExport('/templete/download', searchItem, `ImportTemplate.xlsx`)
  }
  render() {
    const {modalVisible,handleCancel} = this.props
    const { Dragger } = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/china/web/edi/ship/import`

    return (
      <>
        <Modal
          title='Import'
          // closable={false}
          visible={modalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
        >
          <Dragger
            accept=".xls,.xlsx"
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{ width: '100%', margin: '0 auto' }}
            onChange={this.onChange}
            data={{
              importDate: moment(new Date()),
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: 'rgb(154,219,231)'}} />
            </p>
            <p className="ant-upload-text">Click or drag the file here</p>
            <p className="ant-upload-hint" style={{ marginBottom: '10px' }}>
              Download template to fill in and upload
            </p>
          </Dragger>
          <div style={{textAlign: 'center', marginTop: 10}}>
            <Button type="primary" onClick={this.handleExport} style={{width: 180, textAlign: 'center'}}>
              Download Template
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default FormImport;
